import React, { useEffect, useState } from "react";
import MultiSelectInput from "../../../../components/MultiSelectInput";
import RefreshButton from "../../../../components/RefreshButton";
import SearchButton from "../../../../components/SearchButton";
import SelectHookFormMulti from "../../../../components/SelectHookFormMulti";
import { useRecoilState } from "recoil";
import {
  filteredCarrierData,
  isCarrierFiltered,
  selectedCarriers,
} from "../atom/atoms";
import { ICarriers, IStatesOptions } from "../types";
interface ICarrierMainFilter {
  carriersData?: Array<ICarriers>;
  isCarrierLoading: true | false;
}
interface ICarrierOptions {
  label: string;
  value: any;
}
const CarrierMainFilter = ({
  carriersData,
  isCarrierLoading,
}: ICarrierMainFilter) => {
  const [filteredCarrier, setFilteredCarrier] =
    useRecoilState<Array<ICarriers>>(filteredCarrierData);
  const [, setIsFiltered] = useRecoilState<true | false>(isCarrierFiltered);
  const [selectedCarrierIds, setSelectedCarrierIds] =
    useRecoilState<Array<IStatesOptions>>(selectedCarriers);

  const carrierOptions = carriersData?.map((x) => {
    return { label: x.carrierName, value: x.masterCarrierId };
  }) as any;
  const handleSearchButton = () => {
    const carrierIds = selectedCarrierIds.map((x) => x.value) as [
      number | null
    ];
    const filtered = carriersData?.filter((carrier: ICarriers) =>
      carrierIds.includes(carrier.masterCarrierId)
    );
    filtered && setFilteredCarrier(filtered.map((data) => ({ ...data })));
    setIsFiltered(true);
  };
  const handleResetTable = () => {
    setFilteredCarrier([]);
    setSelectedCarrierIds([]);
    setIsFiltered(false);
  };

  return (
    <div className="flex flex-row justify-start space-x-1">
      <SelectHookFormMulti
        options={carrierOptions}
        isLoading={isCarrierLoading}
        value={selectedCarrierIds}
        secondDiv="grid items-center"
        className="border border-gray-300 
          rounded-sm text-xs focus:ring-quaternary focus:border-quaternary"
        onChange={(e) => {
          setSelectedCarrierIds(e);
        }}
      />
      <div className="flex flex-row justify-start space-x-1">
        <SearchButton
          buttonValue="Search"
          className={
            selectedCarrierIds?.length > 0 ? "opacity-100" : "opacity-50"
          }
          onClick={() => handleSearchButton()}
          disabled={selectedCarrierIds?.length > 0 ? false : true}
        />

        <RefreshButton
          className={filteredCarrier?.length > 0 ? "opacity-100" : "opacity-50"}
          onClick={handleResetTable}
          disabled={filteredCarrier?.length > 0 ? false : true}
        />
      </div>
    </div>
  );
};

export default CarrierMainFilter;
